import {
    createSlice
} from "@reduxjs/toolkit";
import {
    getCatalogMob
} from "./thunk";
export const initialState = {
    data: [],
    error: "", // for error message
    loading: false,
};

const mobCatalogSlice = createSlice({
    name: "mobCatalog",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getCatalogMob.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCatalogMob.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getCatalogMob.rejected, (state, action) => {
                state.error = action.payload ? action.payload.error : null;
                state.loading = false;
            })

    }
});

// export const {
//     updateBusinessInfo
// } = businessInfoSlice.actions

export default mobCatalogSlice.reducer;